import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import { TState } from '~/src/store';
import { openChat } from '~/src/store/actions/chat';

import * as ST from './styled';

const CallbackContacts = (): JSX.Element => {
    const analytics = useAnalytics();

    const city = useSelector((state: TState) => state.city.currentCity);
    const dispatch = useDispatch();

    const callCenterNumber = useMemo(() => city.callCenter.replace(/\D/g, ''), [city.callCenter]);
    const href = useMemo(() => `tel:+${callCenterNumber}`, [callCenterNumber]);

    const callTouchHandler = () => {
        analytics.final.clickCallTouch();
    };

    const openChatHandler = () => {
        analytics.final.clickChat();
        dispatch(openChat());
    };

    return (
        <ST.Wrapper>
            <ST.Text>
                Напишите или позвоните в поддержку&nbsp;
                <ST.Phone
                    href={href}
                    className='js-calltouch-phone'
                    data-test='callCenter-link'
                    onClick={callTouchHandler}
                >
                    {city.callCenter}
                </ST.Phone>. Мы всегда на связи.</ST.Text>
            <ST.StBaseButton
                size={btnSizes.LARGE}
                type={btnTypes.SECONDARY}
                text={'Написать в поддержку'}
                onClick={openChatHandler}
                data-test='chat-btn'
            />
        </ST.Wrapper>
    );
};

export default CallbackContacts;
